import { useEffect, useRef, useState } from "react";
import packageJson from "../../../package.json"
import StartChatnew from "../ChatBot/NewChatBotDesign/StartChatnew";
import useSignalR from "../ChatBot/useSignalR";
import { FindFirstChild } from "../../utils/FindMenuOption";
import { useSelector } from "react-redux";
const Footer = () => {
    const API_URL = process.env.REACT_APP_API
    let isChat = FindFirstChild('Miscellaneous', 'Chatbot')?.IsAdd
    const conn = useSignalR(API_URL + "chatHub", 'chatHub').connection
    const year = new Date().getFullYear();
    const [isChatOpen, setIsChatOpen] = useState(false)
    const closeChat = () => {
        setIsChatOpen(false)
    }
    let chatpopup
    if (isChatOpen) {
        chatpopup = <StartChatnew closeChat={closeChat} conn={conn} />
    }
    const [showNotification, setShowNotification] = useState(false);
    const notificationTimeoutRef = useRef(null);

    useEffect(() => {
        if (!conn) return;
        const handleUpdateChatList = (user, message, time, count) => {
            setShowNotification(true);
            // Reset the timer if another notification comes before 3 seconds
            if (notificationTimeoutRef.current) {
                clearTimeout(notificationTimeoutRef.current);
            }
            notificationTimeoutRef.current = setTimeout(() => {
                setShowNotification(false);
            }, 2000);
        };
        conn.on("UpdateChatList", handleUpdateChatList);
        return () => {
            conn.off("UpdateChatList", handleUpdateChatList);
            if (notificationTimeoutRef.current) {
                clearTimeout(notificationTimeoutRef.current);
            }
        };
    }, [conn]);
    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            <div className="footer d-flex align-items-center ">
                <p className="text">© {year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved. v{packageJson.version}</p>
                {/* <span className="need_help app_tooltip left" >
                <HelpIcon classes={'fs-28'}/>
            <p className="xsm_text text-light tool_tip">Need Help? </p>
            </span> */}
                <div className={`app_tooltip left ${showNotification ? 'notify' : ''}`}>
                    <span class="icon-Messages fs-25" onClick={() => setIsChatOpen(!isChatOpen)}><span class="path1"></span><span class="path2"></span></span>
                    <span className="ar_counter"></span>
                    <p className="xsm_text text-light tool_tip">Messages</p>
                </div>
                {chatpopup}
            </div>
        </>

    )
}
export default Footer;